import React from 'react';
import { connect } from 'react-redux';
import { FontIcon, TextField } from 'material-ui';
import RaisedButton from '../../../tc-ui/raised-button-with-loader';
import { propOr } from 'ramda';

const DiscrepancyMsg = ({ updateThisProductWithKeyPath, discrepancyMsg, sendMsg, msgFlags, contractId }) => {
  return (
    <div>
      <div>
        <br/>
        Send a message to your partner about any discrepancies:
        <div style={{ padding: '0 12px 8px 12px', overflow: 'auto', minHeight: '80px', border: '1px solid #00BCD4', margin: '12px 0' }}>
          <FontIcon className="tc-icon-email" color="#bfbfbf" style={{ top: '12px' }} />
          <TextField
            id="commentBoxTextField"
            hintStyle={{ top: '12px' }}
            hintText="Please review the room occupancies or child/infant ages provided in the contract."
            underlineShow={false}
            onChange={({ target: { value } }) => updateThisProductWithKeyPath(['discrepancyMsg'], value)}
            style={{ float: 'right', width: '85%', marginRight: '5%', fontSize: '14px', lineHeight: '18px' }}
            multiLine
            rowsMax={5}
            maxLength="400"
          />
        </div>
        {propOr(false, 'msgSent', msgFlags) ?
          <div>
            Your message has been sent to your partner, click <a href={`/contracting/contract/${contractId}/activities`} target="_blank">here</a> to view your message.
          </div> :
          (<RaisedButton
            secondary
            disabled={!Boolean(discrepancyMsg)}
            loader={propOr(false, 'sendingMsg', msgFlags)}
            style={{ float: 'right' }}
            label="Send"
            onTouchTap={sendMsg}
          />)}
      </div>
    </div>);
};

const mapStateToProps = ({ integration }) => ({
  contractId: integration.getIn(['contract', 'contractId']),
});

export default connect(mapStateToProps)(DiscrepancyMsg);



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/preview-discrepancy-msg-box.jsx